// Import style
import './style.scss';

// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

// Import dom-ready
import domReady from '@wordpress/dom-ready';

// Import images
import './img/delay-or-schedule-actions-landscape-2-2x.png';
import './img/delay-or-schedule-actions-2-2x.png';
import './img/multiple-actions-landscape-2-2x.png';
import './img/multiple-actions-2-2x.png';
import './img/multiple-triggers-landscape-2-2x.png';
import './img/multiple-triggers-2-2x.png';

/**
 * Class representing the Dashboard page.
 */
export default class Dashboard {
	constructor() {
		// Reserved for future dashboard-page bootstrap.
	}

	/**
	 * Determines if the current page is the "Dashboard" page.
	 *
	 * @return {Boolean} True if the current page is the "Dashboard" page.
	 */
	get isDashboardPage() {
		return isDefined( document.getElementById( 'uap-dashboard' ) );
	}
}

domReady( () => {
	new Dashboard();
} );
